<template>
  <div class="cb-reset-password" @keydown="setFocus">
    <h2 class="cb-heading-6" id="dialog-title">Reset Password</h2>
    <p class="cb-body-1">
      To reset your password, you will be taken to MyADT.com to update your
      preferences.
    </p>
    <div class="cb-reset-password__btn-container">
      <button
        @click="closeModal"
        data-tab-order="first"
        ref="closeModalButton"
        class="cb-button cb-button--no-outline"
      >
        CLOSE
      </button>
      <a
        @click="handleNavigate"
        class="cb-button cb-button--no-outline"
        href="https://www.myadt.com/"
        rel="noopener noreferrer"
        target="_blank"
        data-tab-order="last"
        >GO To MyADT</a
      >
    </div>
  </div>
</template>

<script>
/* global gtag */
import { mapActions } from 'vuex';
import focusTrapping from '../../mixins/focusTrapping';

export default {
  mounted() {
    this.$refs.closeModalButton.focus();
  },
  methods: {
    handleNavigate() {
      gtag('event', 'goToADTClick', {
        event_label: 'go to adt',
        event_category: 'forgotPassword',
        value: 1,
      });
    },
    ...mapActions(['closeModal']),
  },
  mixins: [focusTrapping],
};
</script>

<style lang="scss" scoped>
.cb-reset-password {
  width: 88vw;
  max-width: 430px;
  box-sizing: border-box;
  padding: 24px 24px 10px;

  .cb-heading-6 {
    margin-bottom: 12px;
  }

  .cb-body-1 {
    font-size: 18px;
    line-height: 27px;
    margin-bottom: 16px;
  }

  &__btn-container {
    display: flex;
    justify-content: flex-end;
  }

  @include desktop {
    padding: 24px 40px 10px;
  }
}
</style>
